const sliderItems = {
  'sliderItems-1-title-a': 'As a mobile ice cream cart on the Rhine',
  'sliderItems-1-title-b': 'and as an ice cream shop in Westfeld in Basel',
  'sliderItems-2-title': 'About us',
  'sliderItems-3-title': 'Our offer',
  'sliderItems-4-title': 'Catering'
};

export default sliderItems;
